<template>
<footer class="footer is-warning">
  <div class="container">
    <div class="content has-text-centered">
      <p>
        <strong>OOSH Zone Australia © 2018</strong>
      </p>
    </div>
  </div>
</footer>
</template>

<script>
import Documents from './Documents'

export default {
  name: 'Footer',
  components: { Documents }
}
</script>

<style scoped>
.footer {
  background: #e67e22;
}
</style>



// WEBPACK FOOTER //
// src/components/Foot.vue